import { Testimonial } from '../types';

export const testimonials: Testimonial[] = [
  {
    quote:
      "J'ai récupéré 180 000 FCFA de dettes oubliées en 3 mois. L'app s'est payée 10 fois. Avant, c'était le cahier et les disputes avec les clients.",
    name: 'Abdoulaye D.',
    city: 'Dakar',
    role: 'Épicerie de quartier',
    duration: '6 mois',
    rating: 5,
  },
  {
    quote:
      "Avant, il y avait toujours 10 000 ou 20 000 FCFA qui manquaient à la fin de la journée. Maintenant ? Zéro. Chaque vente est enregistrée en temps réel.",
    name: 'Mariam K.',
    city: 'Saint-Louis',
    role: 'Boutique cosmétiques',
    duration: '8 mois',
    rating: 5,
  },
  {
    quote:
      "Avant, je fermais à 23h parce que je recomptais tout. Maintenant je suis chez moi à 22h15 avec mes enfants. Ça n'a pas de prix.",
    name: 'Moussa T.',
    city: 'Kaolack',
    role: 'Alimentation générale',
    duration: '1 an',
    rating: 5,
  },
  {
    quote:
      "Mon bénéfice a augmenté de 40% en 4 mois. Pas parce que je vends plus, mais parce que j'ai arrêté de perdre de l'argent sans le savoir.",
    name: 'Fatou S.',
    city: 'Ziguinchor',
    role: 'Boutique textile',
    duration: '4 mois',
    rating: 5,
  },
  {
    quote:
      "Un client me disait qu'il ne devait rien. J'ai sorti mon téléphone : \"Vous me devez 47 000 FCFA, voici les dates.\" Il a payé sur place.",
    name: 'Ibrahim N.',
    city: 'Touba',
    role: 'Quincaillerie',
    duration: '10 mois',
    rating: 5,
  },
  {
    quote:
      "Je gère 3 boutiques depuis mon téléphone, en temps réel. Avant, je devais être partout physiquement. XamXamBoutik m'a rendu libre.",
    name: 'Aminata B.',
    city: 'Dakar',
    role: 'Multi-boutiques mode',
    duration: '1 an',
    rating: 5,
  },
  {
    quote:
      "Mon fils gère la boutique pendant que je suis à la maison. Je contrôle tout depuis chez moi : ventes, stock, dépenses. C'est la tranquillité.",
    name: 'Cheikh M.',
    city: 'Thies',
    role: 'Dépôt de boissons',
    duration: '7 mois',
    rating: 5,
  },
  {
    quote:
      "Je perdais 80 000 FCFA par mois en frais cachés que je ne voyais pas. Le dashboard m'a ouvert les yeux. Bénéfice en hausse de 25%.",
    name: 'Ousmane G.',
    city: 'Dakar',
    role: 'Accessoires téléphone',
    duration: '5 mois',
    rating: 5,
  },
];
